export default "__VITE_ASSET__CE5G9g____"